import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace } from '../../model';

export const trackCouponRemovedEvent = (params: { name: string }) =>
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.COUPON_REMOVED,
      coupon: {
        action: EcommerceSectionNamespace.EEcommerceCouponAction.COUPON_REMOVED,
        name: params.name,
        interaction: EcommerceSectionNamespace.EEcommerceInteraction.BUTTON,
        type: EcommerceSectionNamespace.EEcommerceCouponType.COUPON,
        status: EcommerceSectionNamespace.EEcommerceStatus.OK,
      },
      _clear: true,
    }),
  );
